// extracted by mini-css-extract-plugin
export default {"item-list":"FriedDesktop_item-list__BmQWT","item":"FriedDesktop_item__0TK5l","category-title":"FriedDesktop_category-title__u26Zm"};